<template>
    <card class="card-plain">
        <p class="gdpr-text pr-4 pl-4">{{$t('GDPR Info')}}</p>
    </card>
</template>

<script>
  export default {
    name: 'GDPR'
  }
</script>

<style lang="scss">
    .gdpr-text {
        white-space: pre-line;
    }
</style>